import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import P1 from '@base/P1/P1';
import Avatar from '@base/Avatar/Avatar';
import { timeAgoSinceDate } from '@utils/dates';
import Card from './Card';

const Container = styled.div`
  display: flex;
  margin-top: 16px;
`;

const Comment = styled(P1)`
  font-size: 12px;
  line-height: 150%;
  color: var(--color-text-primary);
  margin-top: 8px;
`;

const InfoWrapper = styled.div``;

const Info = styled.span`
  font-size: 10px;
  line-height: 100%;
  color: var(--color-text-secondary);
  margin-right: 2px;
`;

const StyledAvatar = styled(Avatar)`
  margin-right: 8px;
  min-width: 40px;
`;

const CommentCard = ({ comment }) => (
  <Container>
    <StyledAvatar src={comment?.user?.avatar} size="40px" />
    <Card>
      <InfoWrapper>
        <Info>{`${comment.user.first_name} ${comment.user.last_name}`}</Info>
        <Info>•</Info>
        <Info>{timeAgoSinceDate(comment.created_at)}</Info>
      </InfoWrapper>
      <Comment>{comment.text}</Comment>
    </Card>
  </Container>
);

export default CommentCard;

CommentCard.propTypes = {
  comment: PropTypes.objectOf(PropTypes.any).isRequired
};
